import AppShell from "@/components/layout/AppShell";
import { StaffClearanceHub } from "@/components/staff-reports/StaffClearanceHub";
import { useAuth } from "@/contexts/AuthContext";

const PRIMARY_OWNER_EMAIL = "todayskidz@comcast.net";

// Roles allowed to edit/configure clearance URLs
const CAN_EDIT_ROLES = ["owner", "co-owner", "director", "assistant_director", "group_supervisor", "supervisor"];

const StaffClearanceHubPage = () => {
  const { user } = useAuth();

  const canEdit =
    user?.email === PRIMARY_OWNER_EMAIL ||
    CAN_EDIT_ROLES.includes(user?.role?.toLowerCase());

  return (
    <AppShell pageTitle="Staff Clearance Hub" breadcrumb>
      <div className="p-4 md:p-6 max-w-7xl mx-auto">
        <StaffClearanceHub isOwner={canEdit} />
      </div>
    </AppShell>
  );
};

export default StaffClearanceHubPage;
